import React from 'react';
import { Ban } from 'lucide-react';
import ShiftCard from './ShiftCard';

const ScheduleCell = ({ shifts, onShiftClick, unavailable = false }) => {
  const showUnavailable = unavailable && shifts.length === 0;
  return (
    <div className="grid-cell">
      {shifts.map((shift, index) => (
        <ShiftCard key={index} shift={shift} onShiftClick={onShiftClick} />
      ))}
      {showUnavailable && (
        <div
          className="grid-cell__unavailable"
          role="img"
          aria-label="Not available this day"
          title="Not available this day"
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#dc2626',
            opacity: 0.6,
          }}
        >
          <Ban size={18} strokeWidth={2} />
        </div>
      )}
    </div>
  );
};

export default ScheduleCell;
